import { render, staticRenderFns } from "./ScoreCard.vue?vue&type=template&id=501d2a72&"
import script from "./ScoreCard.vue?vue&type=script&lang=ts&"
export * from "./ScoreCard.vue?vue&type=script&lang=ts&"
import style0 from "./ScoreCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSeparator} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QSeparator}, component.options.components || {})
